import { makeAutoObservable, toJS } from "mobx";
import { apiLink } from "../helpers/constantVariables";
import {
  apiDelete,
  apiDeleteWithBody,
  apiGet,
  apiPostPut,
} from "../api/api_methods";
import PopupStore from "./popups_store";
class UserStore {
  loading = false;
  dashboardInterviews = [];
  userexperience = [
    {
      company: "",
      designation: "",
      joiningDate: "",
      completionDate: "",
    },
  ];
  date = "";
  notifications = [];
  transactions = {};
  userDetails = {};
  DeletePopup = false;
  organizations = [];
  showVerificationAlert = false;
  hittedApis = {
    interviewList: false,
    userDetails: false,
    listCoupons: false,
  };
  loader = false;

  coupons = [];
  role = null;
  userPic = JSON.parse(localStorage.getItem("user"))?.pic ?? null;
  userIsAccountVerified = JSON.parse(localStorage.getItem("user"))
    ?.isAccountVerified;
  resume = null;
  resumeName = "";
  videoResume = null;
  videoResumeName = "";
  hiredCandidates = [];
  bestPerformers = [];
  bestPerformers2 = [];
  termsAndConditionsPopup = false;
  gender = "";
  showDefault = true;
  clusterHit = false;
  bannerHit = false;
  registerView = false;
  termsAndConditionsView = false;
  resumeReport = null;
  PreviousResumesCount = 0;
  previousSubscriptions = [];
  previousAllSubscriptions = [];
  PreviousResumes = [];
  ResumeSearch = "";
  setPreviousSubscriptions = (details) => {
    this.previousSubscriptions = details;
  };
  setPreviousAllSubscriptions = (details) => {
    this.previousAllSubscriptions = details;
  };
  setResumeSearch = (val) => {
    this.ResumeSearch = val;
  };

  setTermsAndConditionsView = (value) => {
    this.termsAndConditionsView = value;
  };
  setRegisterView = (value) => {
    this.registerView = value;
  };
  setBannerHit = (val) => {
    this.bannerHit = val;
  };
  setClusterHit = (val) => {
    this.clusterHit = val;
  };
  ApplicationDetails = null;
  setApplicationDetails = (details) => {
    this.ApplicationDetails = details;
  };
  setDefault = (val) => {
    this.showDefault = val;
  };
  setGender = (val) => {
    this.gender = val;
  };
  setDate = (date) => {
    this.date = date;
  };
  skills = [];
  setTermsAndConditionsPopup(value) {
    this.termsAndConditionsPopup = value;
  }
  setNotifications(notifications) {
    this.notifications = notifications;
  }
  setDeletePopup(value) {
    this.DeletePopup = value;
  }
  setBestPerformers(details) {
    this.bestPerformers = details;
  }
  setBestPerformers2(details) {
    this.bestPerformers2 = details;
  }
  setHiredCandidates(details) {
    this.hiredCandidates = details;
  }
  pdf = false;
  setUserExperience(experience) {
    console.log("setUserExperience", experience);
    this.userexperience = experience;
  }
  setpdf(val) {
    this.pdf = val;
  }
  setResumeName(val) {
    this.resumeName = val;
  }
  setVideoResumeName(val) {
    this.videoResumeName = val;
  }
  setResume(pic) {
    this.resume = pic;
  }
  setVideoResume(link) {
    this.videoResume = link;
  }
  setUserPic(pic) {
    this.userPic = pic;
  }
  constructor() {
    makeAutoObservable(this);
  }

  setRole(role) {
    this.role = role;
  }

  setOrganizations(details) {
    this.organizations = details;
  }

  addExtraCoins = (coins) => {
    console.log("addExtraCoins", coins);
    console.log("addExtraCoins", toJS(this.userDetails));

    try {
      this.userDetails.coins =
        parseInt(this.userDetails.coins) + parseInt(coins);
      console.log(toJS(this.userDetails.coins));
      // update the local storage
      const userDetailslocal = JSON.parse(localStorage.getItem("user"));
      const mergedData = { ...userDetailslocal, coins: this.userDetails.coins };
      localStorage.setItem("user", JSON.stringify(mergedData));
    } catch (error) {}
  };

  async DeleteUser(Mail, Password) {
    const body = {
      mail: Mail,
      password: Password,
    };
    const response = await apiDeleteWithBody(body, "/user/delete-user");
    // if (response.status === 200) {
    //   console.log(response?.body?.success);
    //   localStorage.removeItem("user");
    // localStorage.removeItem("user_google");
    // localStorage.clear();
    // window.location.href = "/";
    //   return alert(`${response?.body?.message}`);
    // } else {
    //   console.log("this is ", response)
    return response?.body?.message;
  }

  async fetchResumeReportById(id) {
    const response = await apiGet(
      `/resumeAnalyser/get-resumeAnalyser-By-Id/${id}`
    );
    if (response.status === 200) {
      this.resumeReport = response.body.data;
    } else {
      console.log("Failed to fetch resume report");
    }
    return response;
  }

  async fetchResumeReport(body) {
    const id = JSON.parse(localStorage.getItem("user"))?._id;
    const response = await apiPostPut(
      body,
      `/resumeAnalyser/create-resume-improvement/${id}`,
      "POST"
    );
    if (response.status === 200) {
      this.resumeReport = response.body.data;
    } else {
      console.log("Failed to fetch resume report");
      alert(response.body.message); //"You does not have enough credits please purchase it."
    }
    return response;
  }
  async postDetailsForMobileVerification(userid, mobileNumber) {
    const body = {
      userId: userid,
      mobile: mobileNumber,
    };
    const response = await apiPostPut(body, `/user/send-otp`, "POST");
    if (response.status === 200) {
      console.log(response?.body?.success);
      return alert(`${response?.body?.Message}`);
    } else {
      return alert(`${response?.body?.Message}`);
    }
  }

  async postOtpForMobileVerification(userid, otp) {
    const body = {
      userId: userid,
      otp: otp,
    };
    const response = await apiPostPut(body, `/user/verify-otp`, "POST");
    if (response.status === 200) {
      console.log(response?.body?.success);
      return alert(`${response?.body?.Message}`);
    } else {
      return alert(`${response?.body?.Message}`);
    }
  }

  async getRankers() {
    const response = await apiGet("/user/best-performers");
    if (response.status === 200) {
      console.log("rankers", response?.body?.data);
      this.setBestPerformers(JSON.stringify(response.body.data));
      this.setBestPerformers2(response.body.data);
      console.log("UserStore.bestPerformers", this.bestPerformers);
    } else {
      return console.log("Failed to fetch rankers");
    }
  }

  async checkSubscription() {
    const userDetailslocal = JSON.parse(localStorage.getItem("user"));
    const response = await apiGet(
      `/subscriptions/user-subscriptions/${userDetailslocal?._id}`
    );
    if (response.status === 200) {
      console.log("subscription", response?.body?.subscriptions);
      this.setPreviousSubscriptions(toJS(response?.body?.subscriptions[0]));
      console.log("subscriptions1255", toJS(this.previousSubscriptions));

      return true;
    } else {
      return console.log("Failed to fetch subscription");
    }
  }

  async checkAllSubscription() {
    const userDetailslocal = JSON.parse(localStorage.getItem("user"));
    const response = await apiGet(
      `/subscriptions/user-subscriptions/${userDetailslocal?._id}?filter=all`
    );
    if (response.status === 200) {
      console.log("subscription", response?.body?.subscriptions);
      this.setPreviousAllSubscriptions(toJS(response?.body?.subscriptions));
      return response?.body?.subscriptions;
    } else {
      return console.log("Failed to fetch subscription");
    }
  }

  async deleteSubscription(subscriptionId) {
    this.loader = true;
    const response = await apiDelete(
      `/subscriptions/delete-subscription/${subscriptionId}`
    );
    await new Promise((resolve) => setTimeout(resolve, 2000)); // Add a 2-second delay
    this.loader = false;
    if (response.status === 200) {
      console.log("subscription deleted successfully");
      this.checkAllSubscription();
    } else {
      return alert("Failed to delete subscription");
    }
  }

  async getHiredCandidates() {
    try {
      this.loading = true; // Start loading

      const response = await apiGet("/application/hired-candidates");

      if (response.status === 200) {
        console.log("rankers", response?.body?.data);
        this.setHiredCandidates(JSON.stringify(response.body.data));
        console.log("UserStore.bestPerformers", this.bestPerformers);
      } else {
        console.log("Failed to fetch rankers");
      }
    } catch (error) {
      console.error("Error fetching hired candidates", error);
    } finally {
      this.loading = false; // Stop loading
    }
  }

  async GetApplicationProgress(InterviewId, ApplicationId, mcqId) {
    const response = await apiGet(
      `/application/application-status?interviewId=${InterviewId}&applicationId=${ApplicationId}&mcqId=${mcqId}`
    );
    if (response.status === 200) {
      this.setApplicationDetails(response.body.data);
    } else {
      this.setApplicationDetails(null);
      console.log("Failed to fetch application progress");
    }
  }

  async getTransactions({ skip = 0, transactionId = null }) {
    this.loader = true;
    const id = JSON.parse(localStorage.getItem("user"))?._id;
    const response = await apiGet(
      `/transactions/get-transactions?userId=${id}&skip=${skip}&limit=10&transactionId=${transactionId}`
    );
    if (response.status === 200) {
      this.transactions = response.body;
    }
    this.loader = false;
  }

  async getUserDetails(refresh = false) {
    // if (this.userDetails && !refresh) return;
    if (this.userDetails?.name && !refresh) return;
    const userDetailslocal = JSON.parse(localStorage.getItem("user"));
    if (!userDetailslocal) return;
    const response = await apiPostPut(
      { id: userDetailslocal?._id },
      `/user/user-details-with-id`,
      "Post"
    );
    if (response.status === 200) {
      console.log("user-details", response?.body?.data);
      localStorage.setItem("user", JSON.stringify(response?.body?.data));
      return this.setUserDetails(response?.body?.data);
    } else {
      // return alert("something went wrong");
      console.log("something went wrong");
    }
  }

  async updateUserDetailsToServer(updateBody) {
    // update the body to server through put api and then update the user details here
    const userDetailslocal = JSON.parse(localStorage.getItem("user"));
    const response = await apiPostPut(
      updateBody,
      `/user/user-with-id/${userDetailslocal?._id}`,
      "PUT"
    );
    if (response.status === 200) {
      console.log(response?.body?.data);
      const mergedData = { ...this.userDetails, ...response?.body?.data };
      localStorage.setItem("user", JSON.stringify(mergedData));
      return this.setUserDetails(response?.body?.data);
    } else {
      return alert("something went wrong");
    }
  }

  async UpdateUserStatus(body) {
    const userDetailslocal = JSON.parse(localStorage.getItem("user"));

    const response = await apiPostPut(
      body,
      `/user/user-with-id/${userDetailslocal?._id}`,
      "PUT"
    );
    if (response.status === 200) {
      this.setUserDetails(response?.body?.data);
      return true;
    } else {
      alert("something went wrong");
      return false;
    }
  }

  getAllPreviousResumes = async (skip = 0) => {
    this.loader = true;
    try {
      const userDetailslocal = JSON.parse(localStorage.getItem("user"));
      const response = await apiGet(
        `/resumeAnalyser/get-all-resumeAnalyser/${userDetailslocal?._id}?skip=${skip}&searchFilter=${this.ResumeSearch}`
      );
      this.loader = false;
      if (response.status === 200) {
        console.log("previous resumes", response?.body?.data);
        this.PreviousResumes = response?.body?.data;
        this.PreviousResumesCount = response?.body?.count;
      } else {
        return alert("Failed to fetch previous resumes");
      }
    } catch (error) {
      this.loader = false;
    }
  };

  deleteResume = async (resumeId) => {
    const response = await apiDelete(
      `/resumeAnalyser/delete-resumeAnalyser/${resumeId}`
    );
    if (response.status === 200) {
      console.log("resume deleted successfully");
      this.getAllPreviousResumes();
    } else {
      return alert("Failed to delete resume");
    }
  };

  async UpdateUserDetails(
    name,
    college,
    department,
    year,
    designation,
    skills,

    linkedIn,
    gitHub,
    gender,

    roleId
  ) {
    const userDetailslocal = JSON.parse(localStorage.getItem("user"));
    const body = {
      name: name,
      college: college,
      branch: department,
      year: year,
      designation: designation,
      skills: skills,
      resume: this.resume,
      resumeName: this.resumeName,
      videoResume: this.videoResume,
      videoResumeName: this.videoResumeName,
      linkedIn: linkedIn,
      gitHub: gitHub,
      gender: gender,

      role: roleId,
    };
    const response = await apiPostPut(
      body,
      `/user/user-with-id/${userDetailslocal?._id}`,
      "PUT"
    );
    if (response.status === 200) {
      console.log(response?.body?.data);
      const mergedData = { ...this.userDetails, ...response?.body?.data };
      localStorage.setItem("user", JSON.stringify(mergedData));
      return this.setUserDetails(response?.body?.data);
    } else {
      return alert("something went wrong");
    }
  }
  setUserDetails(UserDetails) {
    this.showVerificationAlert = !UserDetails?.isAccountVerified;
    this.userDetails = UserDetails;
  }

  setVerificationAlert(val) {
    this.showVerificationAlert = val ?? false;
  }

  async postRedeemCoupon(couponCode, userId) {
    const body = {
      userId: userId,
      code: couponCode,
    };
    const response = await apiPostPut(
      body,
      `/payment/redeem-promo-code`,
      "POST"
    );
    if (response.status === 200) {
      console.log(response?.body?.data);
      this.addExtraCoins(
        response?.body?.data?.data?.credits ??
          response?.body?.data?.data?.discount
      );
      this.getUserDetails(true);
      alert(response?.body?.data?.message);
      this.getTransactions({});
      return true;
    } else {
      alert(response?.body?.data?.message ?? response?.body?.message);
      return false;
    }
  }

  async hitAllApis(refresh = false) {
    this.fetchDashboardInterviews(refresh);
    this.fetchCoupons(refresh);
  }

  async fetchDashboardInterviews(refresh = false) {
    console.log(this.hittedApis.interviewList);
    if (!refresh && this.hittedApis.interviewList) return;
    console.log("fetchDashboardInterviews 🎉🎉🎉🎉");
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return; // if user is not there then return
    try {
      const response = await apiGet(`/interview/user-interviews/${user?._id}`);
      if (response.status === 200) {
        console.log("dashboard", response.body?.data);
        this.hittedApis.interviewList = true;
        return this.setDashboardInterviews(response.body?.data);
      } else {
        console.log("Failed to fetch dashboard interviews");
      }
    } catch (error) {
      console.error("Error:", error); // Log the error for debugging
      return console.log("Failed to fetch dashboard interviews");
    }
  }

  setDashboardInterviews(interviews) {
    this.dashboardInterviews = interviews;
  }

  async fetchCoupons(refresh = false) {
    if (!refresh && this.hittedApis.listCoupons) return;
    const response = await apiGet("/coupon/list-coupons");
    if (response.status === 200) {
      this.hittedApis.listCoupons = true;
      console.log("coupons", response?.body?.data);
      return this.setCoupons(response?.body?.data);
    } else {
      return alert("Failed to fetch coupons");
    }
  }

  setCoupons(coupons) {
    this.coupons = coupons;
  }

  async autoGenerateBio(
    name,
    college,
    designation,
    qualification,
    year,
    skills
  ) {
    const body = {
      prompt: `Generate a bio for me. My name is ${name}. I am currently working as a ${designation}. I completed my ${qualification} in ${year} at ${college} . I have skills in ${skills}.`,
      // prompt: `Generate a professional bio for me . My name is ${name}. I completed a ${qualification} in ${year} from ${college}. I am currently working as a ${designation}. I have a diverse skill set including ${skills}.`,
      model: 1,
      max_tokens: 300,
      stop: null,
    };
    const response = await apiPostPut(body, "/mock/ai-chat", "POST");
    if (response.status === 200) {
      const updateBody = {
        ...this.userDetails,
        bio: response?.body?.data?.body?.content,
      };
      console.log("bio", response?.body?.data?.body?.content);
      return this.setUserDetails(updateBody);
    } else {
      return alert("Failed to generate");
    }
  }
}
export default UserStore;
